import { createAction, props } from '@ngrx/store';
import { Todo } from './todos.model';

export const addTodo = createAction(
    '[Todo Page] Add Todo',
    props<{ content: string }>()
);

export const removeTodo = createAction(
    '[Todo Page] Remove Todo',
    props<{ id: string }>()
);

export const loadTodos = createAction('[Todo Page] Load Todos');

export const loadTodosSuccess = createAction(
    '[Todo API] Todo Load Success',
    props<{ todos: Todo[] }>()
);

export const loadTodosFailure = createAction(
    '[Todo API] Todo Load Failure',
    props<{ error: string }>()
);
